import LocalStorageKey from '@enums/LocalStorageKey';

class LocalStorageService {
  private prefix: string;

  constructor(prefix: string) {
    this.prefix = prefix;
  }

  private getPrefixedKey(key: LocalStorageKey): string {
    return `${this.prefix}_${key}`;
  }

  setItem<T>(key: LocalStorageKey, value: T): void {
    const prefixedKey = this.getPrefixedKey(key);
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(prefixedKey, serializedValue);
  }

  getItem<T>(key: LocalStorageKey): T | null {
    const prefixedKey = this.getPrefixedKey(key);
    const serializedValue = localStorage.getItem(prefixedKey);
    if (!serializedValue) return null;
    try {
      return JSON.parse(serializedValue) as T;
    } catch (_err) {
      // Fallback for legacy/plain values that were not JSON-encoded
      return serializedValue as unknown as T;
    }
  }

  removeItem(key: LocalStorageKey): void {
    const prefixedKey = this.getPrefixedKey(key);
    localStorage.removeItem(prefixedKey);
  }

  clearWorkspace(workspaceName: string): void {
    // Clear all keys with the workspace name prefix in the name
    Object.keys(localStorage).forEach((key) => {
      if (key.includes(workspaceName)) {
        localStorage.removeItem(key);
      }
    });
  }

  clear(): void {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(this.prefix)) {
        localStorage.removeItem(key);
      }
    });
  }
}

export default new LocalStorageService(LocalStorageKey.APP_STORAGE_PREFIX);
